import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupFamily() {
    const navigate = useNavigate();
   
    const { data: tribeImages = [], isLoading, isError } = useQuery({
        queryKey: ['tribeImages'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-family-images-api`).then((res) => {
            if (res.data.Status === "Success") {
              return res.data.images;
            } else {
              throw new Error(res.data.Message || "Failed to fetch tribe images");
            }
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });

      const {
        data: tribeCaptions = [],
        isLoading: captionLoading,
        isError: captionError,
      } = useQuery({
        queryKey: ['tribeCaptions'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-family-caption-api`).then((res) => {
            if (res.data.Status === "Success") return res.data.captions;
            else throw new Error("Caption fetch failed");
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });

      const [isMarriedFemale, setIsMarriedFemale] = useState(false);
      useEffect(() => {
        axios.get(`${API_URL}/reg-signup-family-checkmarried-api`, { withCredentials: true })
          .then((res) => {
            if (res.data.Status === "Success") {
              const { married, gender } = res.data;
              if (married === 1 && gender === "Female") {
                setIsMarriedFemale(true);
              }
            }
          })
          .catch(() => {
            toast.error("Failed to check user status.");
          });
      }, []);


      const [familyName, setFamilyName] = useState('');
      
      const handleFamilySubmit = async () => {
        if (!familyName.trim()) {
          toast.error("Family name cannot be empty.");
          return;
        }
      
        try {
          const res = await axios.post(
            `${API_URL}/reg-signup-family-update-api`,
            { family_name: familyName },
            { withCredentials: true }
          );

          if (res.data.Status === "Success") {
            if (res.data.relatedFamilies) {
              navigate('/sign-up-select-family', {
                state: { relatedFamilies: res.data.relatedFamilies }
              });
            } else {
              navigate(res.data.redirect);
            }
          } else {
            toast.error("Failed to submit.");
          }
      
          /*if (res.data.Status === "Success") {
            navigate(res.data.redirect);
          } else {
            toast.error("Failed to update Family.");
          }*/
        } catch (error) {
          console.error("Family update failed:", error);
          toast.error("Something went wrong.");
        }
      };

      //update family name
      //on top of component, useState for each input
      const [husbandDetails, setHusbandDetails] = useState({
        first_name: '',
        last_name: '',
        family_name: '',
        alt_family_name: '',
        status: true, // false = deceased, true = alive
        email: '',
        phone_number: ''
      });

      const handleFamilyMarriedSubmit = async () => {
        if (!husbandDetails.family_name.trim()) {
          toast.error("Fill empty fields.");
          return;
        }
      
        try {
          const payload = {
            ...husbandDetails,
            // Optional: remove email and phone_number if deceased
            ...(husbandDetails.status && { email: '', phone_number: '' })
          };
      
          const res = await axios.post(
            `${API_URL}/reg-signup-family-married-update-api`,
            payload,
            { withCredentials: true }
          );
      
          if (res.data.Status === "Success") {
            if (res.data.relatedFamilies) {
              navigate('/sign-up-select-family', {
                state: { relatedFamilies: res.data.relatedFamilies }
              });
            } else {
              navigate(res.data.redirect);
            }
          } else {
            toast.error("Failed to submit.");
          }
        } catch (error) {
          console.error("Family update failed:", error);
          toast.error("Something went wrong.");
        }
      };
      //end update family name

    return (

      <div
      className="min-vh-100 h-100 d-grid align-items-start"
      style={{
        backgroundImage: isLoading
          ? 'none'
          : tribeImages.length > 0
          ? `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${API_URL}/images/${tribeImages[0].image_name})`
          : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
        >
    
    
    
      <div className="row align-items-center g-3 container m-auto">
        
        <div className="col-12 col-md-6 text-white">
          <p className="display-5">
          {captionLoading ? 'Loading caption...' : (
                  tribeCaptions.map((caption, index) => (
                      <span key={index}>{caption.caption}</span>
                  ))
                  )}
          </p>
        </div>
    
        <div className="col-12 col-md-5 col-xl-4 mx-auto">

        <ToastContainer />
        
          <div className="card bg-secondary text-white">
            <div className="card-body">


            {isMarriedFemale ? (
                      <div className='row'>
                        <div className="col-12 ">
                          <h5 className='text-center text-white'>Husband's Details</h5>

                          <div className='row husband-dtls'>
                          <div className='col-6 col-md-6'>
                          <label>First name</label>
                          <input type="text" name="first_name" class="form-control" required 
                          value={husbandDetails.first_name}
                          onChange={(e) => setHusbandDetails({ ...husbandDetails, first_name: e.target.value })}/>
                            </div>
                            <div className='col-6 col-md-6'>
                            <label>Last name</label>
                            <input type="text" name="last_name" class="form-control" required 
                            value={husbandDetails.last_name}
                            onChange={(e) => setHusbandDetails({ ...husbandDetails, last_name: e.target.value })}/>
                            </div>
                          </div>

                          <div className='row husband-dtls'>
                          <div className='col-6 col-md-6'>
                          <label>Family Name</label>
                          <input type="text" name="family_name" class="form-control" required
                          value={husbandDetails.family_name}
                          onChange={(e) => setHusbandDetails({ ...husbandDetails, family_name: e.target.value })} /> 
                            </div>
                            <div className='col-6 col-md-6'>
                            <label>Alternative Name</label>
                            <input type="text" name="alt_family_name" class="form-control"
                            value={husbandDetails.alt_family_name}
                            onChange={(e) => setHusbandDetails({ ...husbandDetails, alt_family_name: e.target.value })} />
                            </div>
                          </div>

                          <div className='row husband-dtls'>
                          <div className='col-6 col-md-6'>

                              <input
                                type="checkbox"
                                name="status"
                                className="form-check-input"
                                id="deceased"
                                checked={husbandDetails.status}
                                onChange={() => setHusbandDetails({ ...husbandDetails, status: !husbandDetails.status })}
                              />

                               <label class="form-check-label" for="deceased"> Deceased</label>
                            </div>
                            <div className='col-6 col-md-6'>
                            </div>
                          </div>
                          
                          {!husbandDetails.status && (
                            <div className='row husband-dtls' style={{marginBottom: '3%'}}>
                              <div className='col-6 col-md-6'>
                                <label>Email</label>
                                <input type="email" name="email" className="form-control" 
                                value={husbandDetails.email}
                                onChange={(e) => setHusbandDetails({ ...husbandDetails, email: e.target.value })} />
                              </div>
                              <div className='col-6 col-md-6'>
                                <label>Phone Number</label>
                                <input type="text" className="form-control" name="phone_number"
                                value={husbandDetails.phone_number}
                                onChange={(e) => setHusbandDetails({ ...husbandDetails, phone_number: e.target.value })} />
                              </div>
                            </div>
                          )}
                          {husbandDetails.status && (
                          <div className='row husband-dtls' style={{marginBottom: '8%'}}>
                         </div>)}

                          <div className='row text-center'>
                          <div className='col-3 col-md-3'>
                            <Link onClick={() => navigate(-1)} class="btn btn-back">Back</Link>
                               
                            </div>
                            <div className='col-6 col-md-6'>
                            </div>

                            <div className='col-3 col-md-3'>
                            <button onClick={handleFamilyMarriedSubmit} className="btn btn-primary" type="submit">
                                Finish</button>
                            </div>
                          </div>
                          
                        </div>
                      </div>

                      

                      
                    ) : (
                
                        <div className='g-3 align-items-end'>

                            <div className="col-12">
                            <input type="text" name="family_name" className="form-control" placeholder="Enter Family Name"
                                    value={familyName} onChange={(e) => setFamilyName(e.target.value)} />
                              </div>

                              <div className="col-12 mb-3" style={{marginTop: '4%'}}>
                              <div className="d-flex justify-content-between">
                             <Link onClick={() => navigate(-1)} class="btn btn-back">Back</Link> 
                            
                            
                            <button onClick={handleFamilySubmit} className="btn btn-primary" type="submit">
                                Finish</button>

                                </div>
                            </div>
                        </div>
                        
                      )}
             
                {/*<div className="row g-3 align-items-end">
                  <div className="col-12">
                  <ToastContainer />

                              
                  </div>
    
                  <div className="col-12 mb-3">
                    <div className="d-flex justify-content-between">
                    <Link onClick={() => navigate(-1)} class="btn btn-back">Back</Link>
                      <button
                        onClick={handleFamilySubmit} className="btn btn-primary" type="submit"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>*/}
              
            </div>
          </div>
        </div>
      </div>
    </div>


    );
}

export default SignupFamily;
